export const $ = document.querySelector.bind(document);
export const $$ = document.querySelectorAll.bind(document);
export const isMobile = (window.innerWidth
	|| document.documentElement.clientWidth
	|| document.body.clientWidth) <= 768;

function setCookie(name, value, options) {
  options = options || {};
  let expires = options.expires;

  if (typeof expires === 'number' && expires) {
    let d = new Date();
    d.setTime(d.getTime() + expires * 1000);
    expires = options.expires = d;
  }
  if (expires && expires.toUTCString) {
    options.expires = expires.toUTCString();
  }

  value = encodeURIComponent(value);

  let updatedCookie = name + '=' + value;

  for (let propName in options) {
    updatedCookie += '; ' + propName;
    let propValue = options[propName];
    if (propValue !== true) {
      updatedCookie += '=' + propValue;
    }
  }

  document.cookie = updatedCookie;
}

setCookie('bar_shown', 1);


// WEBPACK FOOTER //
// ./wordpress/wp-content/themes/foach/js/modules/utils.js